import React from "react";

export default function Validator({content}) {
    return (
        <div className="col-4 col-md-4 col-lg-3">
            <div className="inner">
                <img src={content.url} alt={content.title}/>
            </div>
        </div>
    )
}
